<template>
  <div>
    <div class="form_item" :class="save_to + '_wrapper'">
      <div :id="save_to + '_element'">
        <Label :required="required" :label="label" :for_id="save_to" />
        <textarea
          v-validate="validation"
          :id="save_to"
          :type="type"
          :name="validationLabel || label"
          :key="save_to"
          :ref="save_to"
          v-model="val"
          :required="required"
          :class="{ 'has-error': errors.has(validationLabel || label) }"
          :pattern="pattern"
          :placeholder="placeholder"
          :row="row"
          :col="col"
        ></textarea>
      </div>
      <p v-if="info !== undefined" class="info" v-html="info"></p>
      <span
        class="error"
        v-show="
          errors.has(validationLabel || label) &&
          ((fields[validationLabel || label].untouched &&
            !fields[validationLabel || label].dirty) ||
            (fields[validationLabel || label].touched &&
              fields[validationLabel || label].dirty))
        "
        v-text="errors.first(validationLabel || label)"
      ></span>
    </div>
  </div>
</template>

<script>
import { validatorComponent } from "./validatorComponentMixin";
import Label from "./Label";

export default {
  name: "InputNumber",
  mixins: [validatorComponent],
  data: function () {
    return {
      validation: { unique: false },
    };
  },
  components: {
    Label,
  },
  props: {
    save_to: String,
    type: {
      type: String,
      default: "text",
    },
    row: Number,
    col: Number,
    validationLabel: String,
    unique: Boolean,
    _id: String,
    operationId: String,
    validationRules: [String, Object],
    autocomplete: String,
    placeholder: String,
    required: {
      type: Boolean,
      default: false,
    },
    pattern: String,
  },
  created() {
    const validationRules = { ...this.validationRules };
    if (validationRules.included) {
      validationRules.included = validationRules.included.split(",");
    }
    if (this.unique) {
      this.validation = {
        ...validationRules,
        unique: [this.save_to, this.operationId],
      };
    } else {
      this.validation = { ...validationRules };
    }
  },
};
</script>
